<template>
  <label
    class="st-switch"
    :class="{ 'st-switch--checked': value }"
    :aria-label="ariaLabel"
  >
    <span style="display: none">{{ ariaLabel }}</span>
    <input
      type="checkbox"
      class="st-switch__input"
      v-model="value"
      :tabindex="tabindex"
      :aria-label="ariaLabel"
    />

    <div class="st-switch__track"></div>
    <div class="st-switch__thumb"></div>

    <div class="st-switch__focus-ring"></div>
  </label>
</template>

<script>
export default {
  name: "st-switch",
  data() {
    return {
      value: false,
    };
  },
  props: {
    checked: Boolean,
    tabindex: {
      type: String,
      default: "1",
    },
    ariaLabel: {
      type: String,
      default: "Växlingsknapp",
    },
  },
  mounted() {
    if (this.checked) this.value = true;
  },
  watch: {
    value(val) {
      this.$emit("input", val);
      this.$emit("togglechanged");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

// Google Material design specific variables (Not part of ST Guidelines)
$primary: #2196f3;
$thumb-size: 20px;
$thumb-bg-color: #fafafa;
$track-width: 34px;
$track-height: 14px;
$focus-ring-size: 42px;

$focus-ring-left: -11px;
$focus-ring-top: -11px;

.st-switch {
  position: relative;
  &--checked {
    .st-switch__track {
      background-color: rgba($primary, 0.5);
    }

    .st-switch__thumb {
      left: rem-calc(14);
      background-color: $primary;
    }

    .st-switch__focus-ring {
      left: $focus-ring-left + 14px;
      background-color: rgba($primary, 0.12);
    }
  }

  &__track {
    position: absolute;
    top: 3px;

    height: $track-height;
    width: $track-width;

    background-color: rgba(black, 0.26);
    border-radius: rem-calc(8);

    transition: background-color 0.1s linear;
  }

  &__thumb {
    position: absolute;
    top: 0;
    left: 0;

    width: $thumb-size;
    height: $thumb-size;

    border-radius: 50%;
    background-color: $thumb-bg-color;

    box-shadow: 0 rem-calc(1) rem-calc(3) rgba(black, 0.4);

    transition: all 0.2s ease;
  }

  &__focus-ring {
    position: absolute;
    top: $focus-ring-top;
    left: $focus-ring-left;
    z-index: -1;

    border-radius: 50%;
    width: $focus-ring-size;
    height: $focus-ring-size;

    background-color: rgba(black, 0.1);
    transform: scale(0);
    opacity: 0;

    transition: all 0.2s ease;
  }

  &__input {
    position: absolute;
    opacity: 0;

    &:focus ~ .st-switch__focus-ring {
      transform: scale(1);
      opacity: 1;
    }
  }
}
</style>
